module.exports = __webpack_public_path__ + "static/media/averta-bold.74ce1c01.woff2";